import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@app/models/shared.model';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DialogComponent implements OnInit {

  dialogData!: DialogData;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: DialogData,
    private readonly _matDialogRef: MatDialogRef<DialogComponent>
  ) {
    this.dialogData = { ...data };
  }

  ngOnInit(): void { 
    // no initial operations required
  }

  send(): void {
    this._matDialogRef.close(true);
  }

  cancel(): void {
    this._matDialogRef.close(false);
  }

}
